import { configureStore } from "@reduxjs/toolkit";
import bureauReducer from "./bureau.slice";
import dashboardReducer from "./dashboard.slice";

export const store = configureStore({
  reducer: {
    bureau: bureauReducer,
    dashboard: dashboardReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
